<nav
  #navbarRoot
  class="bg-neutral-color-neutral-1 border-b-[0.4px] border-neutral-color-neutral-6">

  <!--  DESKTOP   -->
  <div class="hidden lg:grid w-full max-w-[1280px] h-[84px] px-6 items-center grid-cols-[auto_minmax(360px,623px)_auto] gap-6 mx-auto relative z-[65]">
    <!-- Left: Logo + Search -->
    <div class="contents">
      <!-- Logo -->
      <a routerLink="/app" class="flex h-[36px] items-center gap-[3px] cursor-pointer" aria-label="Encargomio">
        <div class="flex w-[24px] h-[24px] flex-shrink-0">
          <img src="home/navbar/Logo Icon.svg" alt="Icono Encargomio" class="w-full h-full" />
        </div>
        <div class="flex w-[80px] h-[14px] flex-shrink-0 pt-[1.368px]">
          <img src="home/navbar/Logo Text.svg" alt="Encargomio" class="w-[79.916px] h-[13.01px]" />
        </div>
      </a>

      <!-- Search -->
      <div class="flex h-[32px] w-full min-w-0 items-stretch">
        <div class="flex w-[45px] flex-shrink-0 items-center justify-center">
          <button
            type="button"
            class="flex h-[32px] w-[36px] flex-shrink-0 items-center justify-center rounded-[var(--Radius-2)]
                   border-0 cursor-pointer bg-[linear-gradient(225deg,var(--Brand-Gradient-Start)_18.26%,var(--Brand-Gradient-End)_96.72%)]
                   hover:opacity-90 transition-opacity"
            (click)="pasteLinkFromClipboard()"
            [attr.aria-label]="'NAVBAR.PASTE_LINK' | translate"
          >
            <img [src]="icons.copyLink" alt="" class="w-[18px] h-[18px]" />
          </button>
        </div>

        <div class="flex flex-1 min-w-0 items-stretch">
        <!-- Input -->
        <div class="flex-1 border-[0.4px] border-neutral-color-neutral-6 rounded-l-[var(--Radius-2)] overflow-hidden
                    focus-within:border-accent-color-accent-9 transition-colors">
          <div class="flex items-center bg-neutral-color-neutral-2 h-full">
            <div class="flex-1 flex items-center px-[12px] h-full">
              <input type="text" [ngClass]="searchValue.length > 0 ? 'bg-[linear-gradient(90deg,var(--Blue-Label-Blue-500)_0%,var(--Red-Label-Red-500)_100%)] bg-clip-text text-transparent [-webkit-text-fill-color:transparent]' : 'text-neutral-color-neutral-11'" class="w-full h-full bg-transparent border-none outline-none overflow-hidden text-ellipsis whitespace-nowrap
                      font-inter font-medium text-[12px] leading-[16px] tracking-[0.04px]
                      placeholder:text-neutral-color-neutral-11"
                [placeholder]="'NAVBAR.SEARCH_PLACEHOLDER' | translate" [(ngModel)]="searchValue"
                (ngModelChange)="onSearchChange($event)" (keydown.enter)="facade.searchOrQuote(searchValue)" />
            </div>
          </div>
        </div>
        <!-- Button -->
        <button [ngClass]="searchValue.length > 0 ? 'rounded-[0_var(--Radius-2)_var(--Radius-2)_0] bg-[linear-gradient(74deg,var(--Blue-Label-Blue-500)_0%,var(--Red-Label-Red-500)_101.98%)]' : 'rounded-r-[var(--Radius-2)] bg-neutral-color-neutral-12'" class="flex items-center justify-center self-stretch p-[8px]
                border-0 border-neutral-color-neutral-12 cursor-pointer hover:opacity-90 transition-opacity"
          (click)="facade.searchOrQuote(searchValue)">
          <span
            class="font-inter font-semibold text-[12px] leading-[16px] tracking-[0.04px] text-neutral-color-neutral-1 whitespace-nowrap">
            {{ 'NAVBAR.SEARCH_BUTTON' | translate }}
          </span>
        </button>
        </div>
      </div>
    </div>

    <!-- Right: Links -->
    <div class="ml-auto flex shrink-0 items-center gap-[1px]">
      <a routerLink="/orders" routerLinkActive="text-red-label-red-300" #rlaOrders="routerLinkActive"
        class="flex flex-col justify-between items-center p-2 rounded-[var(--Radius-2)]
                text-neutral-color-neutral-12 font-inter text-[12px] font-semibold leading-[16px] tracking-[0.04px]
                h-[32px] overflow-visible hover:text-red-label-red-300 transition-colors">
        <span>{{ 'NAVBAR.ORDERS' | translate }}</span>
        @if (rlaOrders.isActive) {
          <div class="w-[6px] h-[6px] border-[3px] border-red-label-red-300 rounded-full"></div>
        }
      </a>

      <a routerLink="/locker" routerLinkActive="text-red-label-red-300" #rlaLocker="routerLinkActive"
        class="flex flex-col justify-between items-center p-2 rounded-[var(--Radius-2)]
                text-neutral-color-neutral-12 font-inter text-[12px] font-semibold leading-[16px] tracking-[0.04px]
                h-[32px] overflow-visible hover:text-red-label-red-300 transition-colors">
        <span>{{ 'NAVBAR.LOCKER' | translate }}</span>
        @if (rlaLocker.isActive) {
          <div class="w-[6px] h-[6px] border-[3px] border-red-label-red-300 rounded-full"></div>
        }
      </a>

      <a routerLink="/shipments" routerLinkActive="text-red-label-red-300" #rlaShipments="routerLinkActive"
        class="flex flex-col justify-between items-center p-2 rounded-[var(--Radius-2)]
                text-neutral-color-neutral-12 font-inter text-[12px] font-semibold leading-[16px] tracking-[0.04px]
                h-[32px] overflow-visible hover:text-red-label-red-300 transition-colors">
        <span>{{ 'NAVBAR.SHIPPING' | translate }}</span>
        @if (rlaShipments.isActive) {
          <div class="w-[6px] h-[6px] border-[3px] border-red-label-red-300 rounded-full"></div>
        }
      </a>

      <a routerLink="/store" routerLinkActive="text-red-label-red-300" #rlaStore="routerLinkActive"
        class="flex flex-col justify-between items-center p-2 rounded-[var(--Radius-2)]
                text-neutral-color-neutral-12 font-inter text-[12px] font-semibold leading-[16px] tracking-[0.04px]
                h-[32px] overflow-visible hover:text-red-label-red-300 transition-colors">
        <span>{{ 'NAVBAR.STORE' | translate }}</span>
        @if (rlaStore.isActive) {
          <div class="w-[6px] h-[6px] border-[3px] border-red-label-red-300 rounded-full"></div>
        }
      </a>

      <!-- Carrito -->
      <a routerLink="/cart" routerLinkActive="text-red-label-red-300" [routerLinkActiveOptions]="{ exact: true }"
        #rlaCart="routerLinkActive"
        class="relative flex flex-col justify-between items-center p-2 rounded-[var(--Radius-2)]
                text-neutral-color-neutral-12 font-inter text-[12px] font-semibold leading-[16px] tracking-[0.04px]
                h-[32px] overflow-visible hover:text-red-label-red-300 transition-colors">
        @if (cartItemCount() > 0) {
          <span
            class="absolute left-[16px] top-0 z-[1] flex h-[14px] min-w-[14px] items-center justify-center rounded-full bg-[#F5234B] px-[3px] font-inter text-[10px] font-bold leading-[14px] text-white">
            {{ cartBadgeText() }}
          </span>
        }

        <div class="flex items-center gap-[4px]">
          <span
            aria-hidden="true"
            class="relative flex h-[14px] w-[13px] shrink-0">
            <span
              class="absolute left-0 top-[2px] h-[12px] w-[13px] bg-current [-webkit-mask:url(/home/navbar/Cart%20Icon.svg)_center/contain_no-repeat] [mask:url(/home/navbar/Cart%20Icon.svg)_center/contain_no-repeat]">
            </span>
          </span>
          <span>{{ 'NAVBAR.CART' | translate }}</span>
        </div>
        @if (rlaCart.isActive) {
          <div class="w-[6px] h-[6px] border-[3px] border-red-label-red-300 rounded-full"></div>
        }
      </a>

      <a routerLink="/account" routerLinkActive="text-red-label-red-300" #rlaCuenta="routerLinkActive"
        class="flex flex-col justify-between items-center p-2 rounded-[var(--Radius-2)]
               text-neutral-color-neutral-12 font-inter text-[12px] font-semibold leading-[16px] tracking-[0.04px]
               h-[32px] overflow-visible hover:text-red-label-red-300 transition-colors">
        <span>{{ 'NAVBAR.ACCOUNT' | translate }}</span>
        @if (rlaCuenta.isActive) {
          <div class="w-[6px] h-[6px] border-[3px] border-red-label-red-300 rounded-full"></div>
        }
      </a>

      <!-- Notifications -->
      <button type="button"
        class="hidden shrink-0 p-2 rounded-[var(--Radius-2)] border-0 bg-transparent text-neutral-color-neutral-12 hover:text-red-label-red-300 transition-colors"
        (click)="facade.openNotifications()" [attr.aria-label]="'NAVBAR.NOTIFICATIONS' | translate">
        <img [src]="icons.notification" alt="Notificaciones" class="w-[12px] h-[12px] max-w-none shrink-0" />
      </button>

      <!-- Menu -->
      <button type="button"
        class="flex shrink-0 items-center gap-1 p-2 rounded-[var(--Radius-2)] border-0 bg-transparent
               text-neutral-color-neutral-12 font-inter text-[12px] font-semibold leading-4 tracking-[0.04px]
               hover:text-red-label-red-300 transition-colors cursor-pointer"
        (click)="facade.openMenu()" [attr.aria-label]="'NAVBAR.MENU' | translate">
        <img [src]="icons.menu" alt="Menú" class="w-[12px] h-[12px] max-w-none shrink-0" />
        <span>{{ 'NAVBAR.MENU' | translate }}</span>
      </button>
    </div>
  </div>

  <!--  TABLET  -->
  <div class="hidden md:flex lg:hidden w-full p-6 bg-neutral-color-neutral-1 relative z-[65]">
    <div class="flex justify-between items-center w-full max-w-[744px] mx-auto">

      <!-- Logo -->
      <a routerLink="/app" class="flex h-[36px] items-center gap-[3px] cursor-pointer flex-shrink-0" aria-label="Encargomio">
        <div class="w-[24px] h-[24px]">
          <img src="home/navbar/Logo Icon.svg" alt="Icono Encargomio" class="w-full h-full" />
        </div>
        <div class="flex w-[80px] h-[14px] pt-[1.368px] flex-col justify-between items-start">
          <img src="home/navbar/Logo Text.svg" alt="Encargomio" class="w-[79.916px] h-[13.01px] flex-shrink-0" />
        </div>
      </a>

      <!-- Search 322 -->
      <div class="flex items-stretch gap-[10px] w-[322px]">
        <button
          type="button"
          class="flex h-8 w-[33px] flex-shrink-0 items-center justify-center rounded-[var(--Radius-2)]
                 border-0 cursor-pointer bg-[linear-gradient(201.262deg,var(--Brand-Gradient-Start)_18.26%,var(--Brand-Gradient-End)_96.72%)]
                 hover:opacity-90 transition-opacity"
          (click)="pasteLinkFromClipboard()"
          [attr.aria-label]="'NAVBAR.PASTE_LINK' | translate"
        >
          <img [src]="icons.copyLink" alt="" class="w-[15px] h-[15.75px]" />
        </button>

        <div class="flex flex-1 min-w-0 items-stretch">
        <div class="flex-1 border-[0.4px] border-neutral-color-neutral-6 rounded-l-[var(--Radius-2)] overflow-hidden h-8
                    focus-within:border-accent-color-accent-9 transition-colors">
          <div class="flex items-center bg-neutral-color-neutral-2 h-full">
            <div class="flex-1 flex items-center px-[6px] h-full">
              <input type="text" [ngClass]="searchValue.length > 0 ? 'bg-[linear-gradient(90deg,var(--Blue-Label-Blue-500)_0%,var(--Red-Label-Red-500)_100%)] bg-clip-text text-transparent [-webkit-text-fill-color:transparent]' : 'text-neutral-color-neutral-11'" class="w-full h-full bg-transparent border-none outline-none overflow-hidden text-ellipsis whitespace-nowrap
                      font-inter font-medium text-[12px] leading-[16px] tracking-[0.04px]
                      placeholder:text-neutral-color-neutral-11"
                [placeholder]="'NAVBAR.SEARCH_PLACEHOLDER' | translate" [(ngModel)]="searchValue"
                (ngModelChange)="onSearchChange($event)" (keydown.enter)="facade.searchOrQuote(searchValue)" />
            </div>
          </div>
        </div>
        <button [ngClass]="searchValue.length > 0 ? 'rounded-[0_var(--Radius-2)_var(--Radius-2)_0] bg-[linear-gradient(74deg,var(--Blue-Label-Blue-500)_0%,var(--Red-Label-Red-500)_101.98%)]' : 'rounded-r-[var(--Radius-2)] bg-neutral-color-neutral-12'" class="h-8 flex items-center justify-center px-[6px]
                border-0 border-neutral-color-neutral-12 cursor-pointer hover:opacity-90 transition-opacity"
          (click)="facade.searchOrQuote(searchValue)">
          <span
            class="font-inter font-semibold text-[10px] leading-[16px] tracking-[0.04px] text-neutral-color-neutral-1 whitespace-nowrap">
            {{ 'NAVBAR.SEARCH_BUTTON' | translate }}
          </span>
        </button>
        </div>
      </div>

      <!-- Links: Órdenes + Cuenta + Notif -->
      <div class="flex items-center gap-[1px] flex-shrink-0">
        <a routerLink="/orders" routerLinkActive="text-red-label-red-300" #rlaOrdersTablet="routerLinkActive"
          class="flex flex-col justify-between items-center p-2 rounded-[var(--Radius-2)]
                 text-neutral-color-neutral-12 font-inter text-[12px] font-semibold leading-[16px] tracking-[0.04px]
                 h-[32px] overflow-visible hover:text-red-label-red-300 transition-colors">
          <span>{{ 'NAVBAR.ORDERS' | translate }}</span>
          @if (rlaOrdersTablet.isActive) {
            <div class="w-[6px] h-[6px] border-[3px] border-red-label-red-300 rounded-full"></div>
          }
        </a>

        <a routerLink="/shipments" routerLinkActive="text-red-label-red-300" #rlaShipmentsTablet="routerLinkActive"
          class="flex flex-col justify-between items-center p-2 rounded-[var(--Radius-2)]
                 text-neutral-color-neutral-12 font-inter text-[12px] font-semibold leading-[16px] tracking-[0.04px]
                 h-[32px] overflow-visible hover:text-red-label-red-300 transition-colors">
          <span>{{ 'NAVBAR.SHIPPING' | translate }}</span>
          @if (rlaShipmentsTablet.isActive) {
            <div class="w-[6px] h-[6px] border-[3px] border-red-label-red-300 rounded-full"></div>
          }
        </a>

        <a routerLink="/account" routerLinkActive="text-red-label-red-300" #rlaCuentaTablet="routerLinkActive"
          class="flex flex-col justify-between items-center p-2 rounded-[var(--Radius-2)]
                 text-neutral-color-neutral-12 font-inter text-[12px] font-semibold leading-[16px] tracking-[0.04px]
                 h-[32px] overflow-visible hover:text-red-label-red-300 transition-colors">
          <span>{{ 'NAVBAR.ACCOUNT' | translate }}</span>
          @if (rlaCuentaTablet.isActive) {
            <div class="w-[6px] h-[6px] border-[3px] border-red-label-red-300 rounded-full"></div>
          }
        </a>

        <button type="button"
          class="hidden p-2 rounded-[var(--Radius-2)] border-0 bg-transparent text-neutral-color-neutral-12 hover:text-red-label-red-300 transition-colors"
          (click)="facade.openNotifications()" [attr.aria-label]="'NAVBAR.NOTIFICATIONS' | translate">
          <img [src]="icons.notification" [alt]="'NAVBAR.NOTIFICATIONS' | translate" class="w-[12px] h-[12px]" />
        </button>
      </div>
    </div>
  </div>

  <!--  MOBILE  -->
  <div class="flex md:hidden w-full max-w-[430px] mx-auto px-3 pt-3 pb-3 flex-col gap-2 bg-neutral-color-neutral-1 relative z-[65]">
    <!-- Row 1 -->
    <div class="flex justify-between items-center w-full">
      <!-- Logo -->
      <a routerLink="/app" class="flex h-[36px] px-2 items-center gap-[3px] cursor-pointer" aria-label="Encargomio">
        <div class="w-[24px] h-[24px] aspect-square">
          <img src="home/navbar/Logo Icon.svg" alt="Icono Encargomio" class="w-full h-full" />
        </div>
        <div class="flex w-[80px] h-[14px] pt-[1.368px] flex-col justify-between items-start">
          <img src="home/navbar/Logo Text.svg" alt="Encargomio" class="w-[79.916px] h-[13.01px] flex-shrink-0" />
        </div>
      </a>

      <!-- Links -->
      <div class="flex items-center">
        <a routerLink="/orders" routerLinkActive="text-red-label-red-300" #rlaOrdersMobile="routerLinkActive"
          class="flex flex-col justify-between items-center p-2 rounded-[var(--Radius-2)]
                 text-neutral-color-neutral-12 font-inter text-[12px] font-semibold leading-[16px] tracking-[0.04px]
                 h-[32px] overflow-visible hover:text-red-label-red-300 transition-colors">
          <span>{{ 'NAVBAR.ORDERS' | translate }}</span>
          @if (rlaOrdersMobile.isActive) {
            <div class="w-[6px] h-[6px] border-[3px] border-red-label-red-300 rounded-full"></div>
          }
        </a>

        <a routerLink="/shipments" routerLinkActive="text-red-label-red-300" #rlaShipmentsMobile="routerLinkActive"
          class="flex flex-col justify-between items-center p-2 rounded-[var(--Radius-2)]
                 text-neutral-color-neutral-12 font-inter text-[12px] font-semibold leading-[16px] tracking-[0.04px]
                 h-[32px] overflow-visible hover:text-red-label-red-300 transition-colors">
          <span>{{ 'NAVBAR.SHIPPING' | translate }}</span>
          @if (rlaShipmentsMobile.isActive) {
            <div class="w-[6px] h-[6px] border-[3px] border-red-label-red-300 rounded-full"></div>
          }
        </a>

        <a routerLink="/account" routerLinkActive="text-red-label-red-300" #rlaCuentaMobile="routerLinkActive"
          class="flex flex-col justify-between items-center p-2 rounded-[var(--Radius-2)]
                 text-neutral-color-neutral-12 font-inter text-[12px] font-semibold leading-[16px] tracking-[0.04px]
                 h-[32px] overflow-visible hover:text-red-label-red-300 transition-colors">
          <span>{{ 'NAVBAR.ACCOUNT' | translate }}</span>
          @if (rlaCuentaMobile.isActive) {
            <div class="w-[6px] h-[6px] border-[3px] border-red-label-red-300 rounded-full"></div>
          }
        </a>

        <button type="button"
          class="hidden p-2 rounded-[var(--Radius-2)] border-0 bg-transparent text-neutral-color-neutral-12 hover:text-red-label-red-300 transition-colors"
          (click)="facade.openNotifications()" [attr.aria-label]="'NAVBAR.NOTIFICATIONS' | translate">
          <img [src]="icons.notification" alt="Notificaciones" class="w-[12px] h-[12px]" />
        </button>
      </div>
    </div>

    <!-- Divider -->
    <div class="h-[1px] w-full bg-neutral-color-neutral-2"></div>

    <!-- Search -->
    <div class="flex items-start gap-[10px] w-full pt-[2px]">
      <button
        type="button"
        class="flex h-[34px] w-[34px] flex-shrink-0 items-center justify-center rounded-[var(--Radius-2)]
               border-0 cursor-pointer bg-[linear-gradient(201.262deg,var(--Brand-Gradient-Start)_18.26%,var(--Brand-Gradient-End)_96.72%)]
               hover:opacity-90 transition-opacity"
        (click)="pasteLinkFromClipboard()"
        [attr.aria-label]="'NAVBAR.PASTE_LINK' | translate"
      >
        <img [src]="icons.copyLink" alt="" class="w-[15px] h-[15.75px]" />
      </button>

      <div class="flex flex-1 min-w-0 items-stretch">
      <div class="flex-1 border-[0.4px] border-neutral-color-neutral-6 rounded-l-[var(--Radius-2)] overflow-hidden h-[34px]
                  focus-within:border-accent-color-accent-9 transition-colors">
        <div class="flex items-center bg-neutral-color-neutral-2 h-full">
          <div class="flex-1 flex items-center px-[12px] h-full">
            <input type="text" [ngClass]="searchValue.length > 0 ? 'bg-[linear-gradient(90deg,var(--Blue-Label-Blue-500)_0%,var(--Red-Label-Red-500)_100%)] bg-clip-text text-transparent [-webkit-text-fill-color:transparent]' : 'text-neutral-color-neutral-11'" class="w-full h-full bg-transparent border-none outline-none overflow-hidden text-ellipsis whitespace-nowrap
                    font-inter font-medium text-[12px] leading-[16px] tracking-[0.04px]
                    placeholder:text-neutral-color-neutral-11" [placeholder]="'NAVBAR.SEARCH_PLACEHOLDER' | translate"
              [(ngModel)]="searchValue" (ngModelChange)="onSearchChange($event)"
              (keydown.enter)="facade.searchOrQuote(searchValue)" />
          </div>
        </div>
      </div>
      <button [ngClass]="searchValue.length > 0 ? 'rounded-[0_var(--Radius-2)_var(--Radius-2)_0] bg-[linear-gradient(74deg,var(--Blue-Label-Blue-500)_0%,var(--Red-Label-Red-500)_101.98%)]' : 'rounded-r-[var(--Radius-2)] bg-neutral-color-neutral-12'" class="h-[34px] flex items-center justify-center px-[10px]
              border-0 border-neutral-color-neutral-12 cursor-pointer hover:opacity-90 transition-opacity" (click)="facade.searchOrQuote(searchValue)">
        <span
          class="font-inter font-semibold text-[12px] leading-[16px] tracking-[0.04px] text-neutral-color-neutral-1 whitespace-nowrap">
          {{ 'NAVBAR.SEARCH_BUTTON' | translate }}
        </span>
      </button>
      </div>
    </div>
  </div>

  @if (menuOpen$ | async) {
  <app-menu [topOffsetPx]="navbarHeightPx" (closed)="facade.closeMenu()" (action)="onMenuAction($event)" />
  }

</nav>
